import { DefaultSections, startPresentation } from "@presentation/Types";

import Introduction from "./Slides/IntroAndOutro/Introduction.vue";
import ThankYou from "./Slides/IntroAndOutro/ThankYou.vue";
import Partnership from "./Slides/Partnership/Partnership.vue";
import ConnectedVehiclesOverview from "./Slides/History/ConnectedVehiclesOverview.vue";
import OurHistory from "./Slides/History/OurHistory.vue";
import WeAreHere from "./Slides/History/WeAreHere.vue";
import UsefulLinks from "./Slides/UsefulLinks/UsefulLinks.vue";
import CarbucksProtect from "./Slides/ConsumerProposition/CarbucksProtect.vue";
import CarbucksProtectVideo from "./Slides/ConsumerProposition/CarbucksProtectVideo.vue";
import CarbucksProtectCategories from "./Slides/ConsumerProposition/CarbucksProtectCategories.vue";
import Carparc from "./Slides/ConsumerProposition/Carparc.vue";
import ProtectSummary from "./Slides/ConsumerProposition/ProtectSummary.vue";
import EarlySignUpOffer from "./Slides/ConsumerProposition/EarlySignUpOffer.vue";
import CarbucksRewards from "../../SharedSlides/ConsumerProposition/CarbucksRewards.vue";
import RewardsSummary from "../../SharedSlides/DealerProposition/RewardsSummary.vue";
import CarbucksProtectProfit from "./Slides/ConsumerProposition/CarbucksProtectProfit.vue";
import CarbucksProtectFeatureList from "./Slides/ConsumerProposition/CarbucksProtectFeatureList.vue";

export const useSalesPresentation = () => startPresentation(
{

    key: 'sales',
    title: 'Sales Presentation (Protect)',
    password: 'cvpg', 
    enableNextSlideIndicator: true,

    theme: {
        logo: '/presidian-group-logo.png',
        headerColor: '#9860a7'
    },

    sections: [

        // Introduction
        { 
            name: DefaultSections.Start, 
            title: 'Introduction',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Introduction,  }
            ],
            images: [
                '/carbucks-driven-by-presidian.png',
                '/carbucks-logo.png',
                '/protect-logo.png',
                '/protect-dashboard-logo.png',
                '/background-overlay.jpg',
                '/pending.jpg'
            ]
        },

        // Carbucks PROTECT
        { 
            name: 'carbucks-protect', 
            title: 'PROTECT - By Presidian',
            displayPageTitle: true,
            isAppendix: false,
            hasTitlePage: true,
            pages: [
                { component: CarbucksProtectVideo, title: 'What is PROTECT?' },
                { component: CarbucksProtect, title: 'Wear and Tear Cover' },
                { component: CarbucksProtectCategories, title: 'Great Benefits, Great Margins' },
                { component: CarbucksProtectFeatureList, title: 'Great Benefits, Great Margins' },
                { component: CarbucksProtectProfit, title: 'Great Benefits, Great Margins' },
                { component: Carparc, title: 'Comprehensive Dashboard' },
                { component: ProtectSummary, title: 'New Upfront Revenue' },
                // { component: EarlySignUpOffer, title: 'Limited Time Offer' }
            ],
            images: [
                '/ConsumerProposition/carbucks-rewards-logo.png',
                '/ConsumerProposition/carbucks-protect-logo.png',
                '/DealerProposition/early-bird-discount-smooth.png',
                '/DealerProposition/carbucks-dashboard-logo.png',
                '/background-overlay-4.jpg',
            ]   
        },

        // Thank You
        { 
            name: DefaultSections.End, 
            title: 'Questions',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { component: ThankYou }
            ],
            images: [ 
                '/background-overlay-3.jpg',
            ]   
        },
        
        // Carbucks Rewards
        { 
            name: 'carbucks-rewards', 
            title: 'Carbucks REWARDS',
            displayPageTitle: true,
            isAppendix: true,
            hasTitlePage: true,
            pages: [
                { component: CarbucksRewards, title: 'Consumer Proposition' },
                { component: RewardsSummary, title: 'Dealer Proposition' }
            ],
            images: [
                '/background-overlay-5.jpg',
            ]   
        },

        // Case Study
        { 
            name: 'case-study'  
        },

        // Point of Sale
        { 
            name: 'point-of-sale'
        },

        // Terms and Conditions
        { 
            name: 'terms-and-conditions'
        },

        // Dealer Cashback
        { 
            name: 'dealer-cashback'  
        },

        // DMS Integration
        { 
            name: 'dms-integration'
        },

        // Our History
        { 
            name: 'history', 
            title: 'Our History',
            displayPageTitle: true,
            isAppendix: true,
            hasTitlePage: false,
            pages: [
                { component: ConnectedVehiclesOverview, title: 'Company Overview', hideTitle: true },
                { component: OurHistory, title: 'Our History' },
                { component: WeAreHere, title: "We are Here" },
            ],
            images: [
                '/History/connected-vehicles-logo-white.png',
                '/History/dealercell.jpg',
                '/History/we-are-here.jpg'
            ]   
        },

        // Partnership
        { 
            name: 'partnership', 
            title: 'Presidian / CV Partnership',
            displayPageTitle: true,
            isAppendix: true,
            hasTitlePage: false,
            pages: [
                { component: Partnership }
            ],
            images: [
                '/connected-vehicles-logo.png',
                '/presidian-group-logo.png',
            ]   
        },

        // LINKS
        { 
            name: 'links', 
            title: 'Useful Links',
            displayPageTitle: true,
            isAppendix: true,
            hasTitlePage: false,
            pages: [
                { component: UsefulLinks }
            ],
            images: [

            ]   
        }

    ]

})
